import React from 'react'

const ApplicationsSvg = ({ fillColor, size }) => {
  return (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 32 32" 
        fill="none"
    >
        <path d="M14.097 7.43652H7.43652V16H14.097V7.43652Z" stroke={fillColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M24.5636 7.43652H17.9031V12.194H24.5636V7.43652Z" stroke={fillColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M24.5636 16H17.9031V24.5635H24.5636V16Z" stroke={fillColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.097 19.8057H7.43652V24.5632H14.097V19.8057Z" stroke={fillColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default ApplicationsSvg